import { c as _c } from "react/compiler-runtime";
import { useLocale, useTranslations } from 'next-intl';
import { useState } from 'react';
import { useIsClient, useMediaQuery } from 'usehooks-ts';
import { countWords, getWordCountThreshold } from '@/lib/text';
import { cn } from '@/lib/utils';
type GenreHeaderProps = {
  genreDescription: string;
  genreTitle: string;
  worldsCount: number;
};
export default function GenreHeader(t0) {
  const $ = _c(28);
  const {
    genreDescription,
    genreTitle,
    worldsCount
  } = t0;
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const t = useTranslations();
  const locale = useLocale();
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const isClient = useIsClient();
  const descriptionWordsCount = countWords(genreDescription);
  const threshold = getWordCountThreshold(locale, isDesktop);
  const showShowMoreButton = descriptionWordsCount > threshold;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsDescriptionExpanded(_temp);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleToggleShowMore = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("bg-background flex flex-col items-center gap-4 pt-4 transition-all lg:flex-row lg:pt-2");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== genreTitle) {
    t3 = <h1 className="header-5 max-md:text-[16px]">{genreTitle}</h1>;
    $[2] = genreTitle;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("user-worlds.genre.worlds");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4 || $[7] !== worldsCount) {
    t5 = <p className="md:body-1 body-2 text-vive-primary-20 mt-2">{worldsCount} {t4}</p>;
    $[6] = t4;
    $[7] = worldsCount;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = !isClient;
  let t7;
  if ($[9] !== t6) {
    t7 = cn("flex gap-1", {
      visible: t6
    });
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = showShowMoreButton && !isDescriptionExpanded;
  let t9;
  if ($[11] !== t8) {
    t9 = cn("md:body-1 body-2 text-vive-primary-20 mt-1 flex-1", {
      truncate: t8
    });
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== genreDescription || $[14] !== t9) {
    t10 = <p className={t9}>{genreDescription}</p>;
    $[13] = genreDescription;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== isDescriptionExpanded || $[17] !== showShowMoreButton || $[18] !== t) {
    t11 = showShowMoreButton && <button className="text-vive-brand-50 hover:text-vive-brand-40 mt-1 h-fit underline" onClick={handleToggleShowMore}>{isDescriptionExpanded ? t("worlds-landing.genre.show-less") : t("worlds-landing.genre.show-more")}</button>;
    $[16] = isDescriptionExpanded;
    $[17] = showShowMoreButton;
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t7) {
    t12 = <div className={t7}>{t10}{t11}</div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t7;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t3 || $[26] !== t5) {
    t13 = <section className={t2}><div className="1.5xl:gap-9 3xl:gap-4 flex w-full flex-col gap-4"><div className="flex flex-1 flex-col gap-1">{t3}{t5}{t12}</div></div></section>;
    $[24] = t12;
    $[25] = t3;
    $[26] = t5;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}
function _temp(prev) {
  return !prev;
}